export function display_error(msg)
{ if(msg) $('.merror p').html(msg);
  $(".merror").click(function() {
      $(".merror, .merror p").stop().fadeOut(500,function() {
      });
    });
  $(".merror, .merror p").stop(true,true);  
  $(".merror").css('height', 'auto');
  $(".merror p").show();
  var barh = $(".merror").height();
  $(".merror p").hide();
  $(".merror").delay(200).show().animate({height: barh},500, function() {
    $(".merror p, .message_img").fadeIn(500);
    $(".merror p, .message_img").delay(10000).fadeOut(500, function() {
        $(".merror").slideUp(1500,function() {
          //$(".merror").css({height: 'auto'});
        });
        
    });
  }); 
};

export function display_notice(msg)
{ if(msg) $('.flash_success > p').html(msg);
  $(".flash_success ").hover(function() {
    $(".flash_success").stop().fadeOut(600);
  });
  $(".flash_success, .flash_success p").stop(true,true);  
  $(".flash_success").css('height', 'auto');
  $(".flash_success p").show();
  var barh = $(".flash_success").height();
  $(".flash_success p").hide();
  $(".flash_success").delay(200).show().animate({height: barh},500, function() {
    $(".flash_success p").fadeIn(500);
    $(".flash_success p").delay(3000).fadeOut(1000, function() {
        $(".flash_success").slideUp(1500,function() { 
        });
    });
  }); 
}


$(document).on("turbolinks:load",function(){
  

  //file selector file name
  $('.file_selector').on('change',function(e){
    var fileName = e.target.files[0].name;
    $(this).next('.custom-file-label').html(fileName);
  });
  //FILTRO RICERCHE
  $('.js-show-index-filters').click(function(){
    //$(".filter-well").slideToggle();
    $("#search-form").slideToggle();
    
    $(this).parents(".filter-wrap").toggleClass("collapsed");    
    //$("#expanded_searching").val( $("#expanded_searching").val() == 'true' ? 'false' : 'true');
    $("span.fa", $(this)).toggleClass("fa-angle-right");
    $("span.fa", $(this)).toggleClass("fa-angle-down");
  });
  // submit auto,matico nella ricerca veloce
  $(".js-quick-search").click(function(){
      $(this).select();
  });
  $(".js-quick-search").val($(".js-quick-search-target").val());
  // Catch the quick search form submit and submit the real form
  $("#quick-search").submit(function(){
    $(".js-quick-search-target").val($(".js-quick-search").val());
    $("#search-form form").submit();
    return false;
  });
  $(".js-submit-filter").click(function(){
    $(".js-quick-search-target").val($(".js-quick-search").val());
    $("#search-form form").submit();
    return false;
  });
  //cancella ricerca
  $(".js-trash-filter").click(function(){
    $(".js-quick-search-target").val(null);
    $('form.search_fields').find('input:not([type=hidden]):not([type=submit]),select').val(null);
    $("#submit_searching").remove();
    $("#search-form form").submit();
    return false;
  });


  //SUMMERNOTE
  $('[data-provider="summernote"]').each(function() {
    $(this).summernote({
      height: 300,
      toolbar: [
        ['style', ['style']],
        ['font', ['bold', 'underline', 'clear']],
        ['fontname', ['fontname']],
        ['fontsize', ['fontsize']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['table', ['table']],
        ['insert', ['link', 'picture', 'video']],
        ['view', ['fullscreen', 'codeview', 'help']],
      ],
      callbacks: {
        onBlurCodeview: function() {
          let codeviewHtml = $(this).siblings('div.note-editor').find('.note-codable').val();
          //console.log("Codeview area loses focus: " + codeviewHtml);
          $(this).val(codeviewHtml);
        }
      }
    })
  });
  
  $('[data-provider="summernote"]').closest('form').submit(function() {
    $('[data-provider="summernote"]').each(function() {
      if ($(this).summernote('isEmpty')) {
        $(this).val('');
      }
    });
  });

  //datepicker
  $('.datepicker').datepicker(
    { language: 'it',
      constrainInput: false
  });
  
  //messaggi di errore
  $(".flash_success p").each(function() {
    if(!(($(this).html()) === "")) 
    { display_notice($(this).html());
    }
  });
  $(".merror p").each(function() {
    if(!(($(this).html()) === "")) 
    { display_error($(this).html());
    }
  });
  

  //DELETE ACTION LINK
  $('body').on('click', '.delete-resource', function() {
    var el = $(this);
    if (confirm(el.data("confirm"))) {
      $.ajax({
        type: 'POST',
        url: $(this).prop("href"),
        data: {
          _method: 'delete',
        },
        dataType: 'script',
        success: function(response) {
          el.parents("tr").fadeOut('hide', function() {
              $(this).remove();
          });
        },
        error: function(response, textStatus, errorThrown) {
          //show_flash('error', response.responseText);
          display_error(response.responseText);
        }
      });
    }
    return false;
  });
});